import { DropShadowFilter } from "pixi-filters";
import { Container, Point, Sprite, Text, TextStyle, Texture } from "pixi.js";
import { GameFont } from "../../../common/GameFont";
import { HBox } from "../../../common/components/ui/HBox";

export class RewardContainer extends Container {

    public constructor(tokensAmount: string, iconTexture: Texture) {
        super();
        const headerText = new Text(`YOU JUST GOT REWARDED WITH`, new RewardCountTextStyle());
        headerText.style.fontSize = 64;
        this.addChild(headerText);
        const hBox = new HBox(25);
        const rewardCountText = new Text(tokensAmount, new RewardCountTextStyle());
        hBox.addChild(rewardCountText);
        const icon = new Sprite(iconTexture);
        icon.y = -4;
        hBox.addChild(icon);
        hBox.position.set(headerText.x + headerText.width * 0.5 - hBox.width * 0.5, 168.5);
        this.addChild(hBox);
        const headerAdditionalText = new Text(`FOR YOUR UPGRADE`, new RewardCountTextStyle());
        headerAdditionalText.style.fontSize = 64;
        headerAdditionalText.position.set(97, 318);
        this.addChild(headerAdditionalText);

        const orangeGlow = new DropShadowFilter({
            offset: new Point(0, 0),
            blur: 20,
            color: 0x0085FF,
            quality: 4.5,
            alpha: 1,
            pixelSize: 1
        });
        hBox.filters = [orangeGlow];
    }
}

class RewardCountTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            fill: "#ffffff",
            align: "center",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 156,
            lineHeight: 216.4,
        }));
    }
}
